<template>
  <div class="pkcon">
    <a-tabs v-model="activeKey">
      <a-tab-pane key="1" tab="教学周期维护">
        <TeachingCycleMaintenance />
      </a-tab-pane>
      <a-tab-pane key="2" tab="日课表维护">
        <DayScheduleMaintenance />
      </a-tab-pane>
      <a-tab-pane key="3" tab="教学楼间距维护">
        <BuildingDistanceMaintenance />
      </a-tab-pane>
      <a-tab-pane key="4" tab="课程要求维护">
        <CourseRequirementMaintenance />
      </a-tab-pane>
      <a-tab-pane key="5" tab="教师要求维护">
        <TeacherRequirementMaintenance />
      </a-tab-pane>
      <a-tab-pane key="6" tab="教学场地要求维护">
        <VenueRequirementMaintenance />
      </a-tab-pane>
      <a-tab-pane key="7" tab="承担单位排课时间设置">
        <UnitSchedulingSetting />
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
import TeachingCycleMaintenance from './modules/TeachingCycleMaintenance.vue';
import DayScheduleMaintenance from './modules/DayScheduleMaintenance.vue';
import BuildingDistanceMaintenance from './modules/BuildingDistanceMaintenance.vue';
import CourseRequirementMaintenance from './modules/CourseRequirementMaintenance.vue';
import TeacherRequirementMaintenance from './modules/TeacherRequirementMaintenance.vue';
import VenueRequirementMaintenance from './modules/VenueRequirementMaintenance.vue';
import UnitSchedulingSetting from './modules/UnitSchedulingSetting.vue';

export default {
  components: {
    TeachingCycleMaintenance,
    DayScheduleMaintenance,
    BuildingDistanceMaintenance,
    CourseRequirementMaintenance,
    TeacherRequirementMaintenance,
    VenueRequirementMaintenance,
    UnitSchedulingSetting
  },
  data() {
    return {
      activeKey: '1'
    };
  }
};
</script>

<style scoped>
.pkcon {
  padding: 20px;
  padding-top:0;
}
</style>    